import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  EvaluateData,
  ServiceLineRoutingQuery,
  ServiceLineRoutingReferences,
} from '@shared/models/service-line-routing.model';
import { environment } from '@env/environment';
import { PlatformService } from '@core/services/platform.service';
import { EMPTY_OPTION } from '../../../feature/routing-rules/constants';
import { SelectItem } from 'primeng/api';

type RoutingReferenceOptions = {
  [K in keyof ServiceLineRoutingReferences]: SelectItem<string>[];
};

@Injectable()
export abstract class QueueBaseService {
  protected API_URL = `${environment.api.RR}/api`;

  protected productName;

  // Product specific API URL fragment
  abstract fragment: string;

  // Unique key for PrimeNg table component
  abstract uniqueKey: string;

  constructor(protected readonly platformService: PlatformService, protected readonly http: HttpClient) {
    this.productName = this.platformService.currentProduct;
  }

  query(query: string): Observable<ServiceLineRoutingQuery> {
    return this.http.post<ServiceLineRoutingQuery>(`${this.API_URL}/${this.fragment}/$query`, `"${query}"`, {
      headers: new HttpHeaders({ 'content-type': 'application/json' }),
    });
  }

  getReferences(): Observable<RoutingReferenceOptions> {
    return this.http.get<ServiceLineRoutingReferences>(`${this.API_URL}/${this.fragment}/references`).pipe(
      map((refs) =>
        Object.keys(refs).reduce(
          (acc, key) => ({
            ...acc,
            [key]: refs[key as keyof ServiceLineRoutingReferences].map((value: string) => ({ value, label: value })),
          }),
          {} as RoutingReferenceOptions
        )
      ),
      map((refs) => ({
        ...refs,
        ...(refs.requestType && { requestType: [EMPTY_OPTION, ...refs.requestType] }),
        ...(refs.serviceLineStatusReason && {
          serviceLineStatusReason: [EMPTY_OPTION, ...refs.serviceLineStatusReason],
        }),
      }))
    );
  }

  getEvaluateQueue(id: string): Observable<EvaluateData> {
    return this.http.get<EvaluateData>(`${this.API_URL}/${this.fragment}/${id}/evaluate`);
  }
}
